import DiscountHistoryDetailed from './contract-dicount-history';

export default class ItemsSimplified {
  description: string;

  beneficiary: string;

  discountHistory: DiscountHistoryDetailed;

  constructor(obj: any = {}) {
    this.description = obj.description || '';
    this.beneficiary = obj.beneficiary || '';
    this.discountHistory = obj.discountHistory || null
  }
}
